import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
// import { Storage } from '@capacitor/storage';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { User } from '../models/user.model';

@Injectable({
  providedIn: "root",
})
export class AcoService {
  constructor(private http: HttpClient) {}

  token: any;
  isLoggedIn = false;
  user: User;

  getUserData(){
    this.user = JSON.parse(localStorage.getItem('user'));
    if(this.user == null){
      this.user = new User('', '', '', '', '', 0,0,0);
    }
    return this.user;
  }

  setUserData(data_array){
    this.user = new User(data_array['id'], data_array['name'], data_array['role_id'], data_array['email'], data_array['filenameCenter'], data_array['center_enableWorkPermit'], data_array['center_enableTask'], data_array['center_enableTimeControl']);
    localStorage.setItem('user', JSON.stringify(this.user));
    return this.user;
  }

  getToken() {

    return new Promise(resolve => {

      if(localStorage.getItem('token')) {
        this.token = localStorage.getItem('token');
        if (this.token != null) {
          this.isLoggedIn = true;
        } else {
          this.isLoggedIn = false;
        }
      }else{
        this.token = null;
        this.isLoggedIn = false;
      }

      setTimeout(() => {
        resolve(this.token);
      }, 10);
    });

    // return Storage.get( {key:"token_auth"}).then(
    //   (data) => {
    //     this.token = data;
    //     if (this.token != null) {
    //       this.isLoggedIn = true;
    //     } else {
    //       this.isLoggedIn = false;
    //     }
    //   },
    //   (error) => {
    //     this.token = null;
    //     this.isLoggedIn = false;
    //   }
    // );
  }

  setToken(token){


    // De momento lo guardo en dos tipos de local storage (solo debería dejar uno: el localStorage)
    // Storage.set(
    //     {
    //       key: 'token_auth',
    //       value: token,
    //     }); // Se utliza en las consultas a la api
    localStorage.setItem('token', token); // Se utiliza para comporbar si el usuario está logueado
  }

  getUserToken(){
    if(localStorage.getItem('token')){
      this.token = localStorage.getItem('token');
    }else{
      this.token = '';
    }

    return this.token;
  }

  isAutenticated(){
    if(this.getUserToken()){
      return true;
    }else{
      return false;
    }
  }

  logout(){
    // Eliminar token
    // .remove({ key: "token_auth"});
    localStorage.removeItem("token");
  }

  // Construir la llamada a la API
  getQuery(query: string) {
    // this.getToken();
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    // console.log(url + query);
    return this.http.get(url + query, { headers });
  }

  // Ralizar las llamadas
  getLogin(username: string, password: string) {
    const url = environment.api;

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    const params = {
      username,
      password,
    };

    return this.http.post(url + "login", params, { headers })
      .pipe(
        map( resp => {
          this.setToken(resp['token']);
          return resp;
        })
      );
  }
  getUser() {
    // this.getToken().then((value) => {
    const query = "get_user";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    // console.log(url + query);
    return this.http.get(url + query, { headers });
    // });
    /* return new Observable(response => {

    }); */
    // return this.getQuery('get_user');
  }

  rememberPassword(filters = {}) {
    const query = "remember_password";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      filters,
    };

    return this.http.post(url + query, params, { headers });
  }

  getSummaryWorksPermit() {
    const query = "work_permit_summary";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.get(url + query, { headers });
  }

  getWorksPermit(type:string, filters = {}) {
    const query = "get_works_permit/" + type;
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      filters,
    };

    return this.http.post(url + query, params, { headers });
  }

  getWorkPermitPreview(id, is_new_work_permit) {
    let query = '';
    if(is_new_work_permit == 1){
      query = "preview_work_permit/" + id;
    }else{
      query = "preview_work_permit_result/" + id;
    }
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.get(url + query, { headers });
  }

  getWorkPermit(id, is_new_work_permit, taskId) {
    // this.getToken().then((value) => {
    let query = "";
    if (is_new_work_permit == 1) {
      query = "work_permit/" + id;
    } else {

      //Si tiene tarea entonces enviarmos como parametro
      if(taskId != null)
      {
        query = "work_permit_result/" + id + "/" + taskId;
      }else{
        query = "work_permit_result/" + id;   
      }
    }
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    // console.log(url + query);
    return this.http.get(url + query, { headers });
    // });
    /* return new Observable(response => {

    }); */
    // return this.getQuery('get_user');
  }

  saveWorkPermit(data, update_work_permit = false) {
    let query = '';
    if(update_work_permit){
      // El permiso de trabajo ya existe, los datos de form se sobreescriben
      query = "update_work_permit";
    }else{
      // Guardar nuevo permiso de trabajo
      query = "save_work_permit";
    }
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      data,
    };

    return this.http.post(url + query, params, { headers });
  }

  supervisorResponseWorkPermit(data) {
    const query = "response_work_permit_supervisor";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      data,
    };

    return this.http.post(url + query, params, { headers });
  }

  finishResponseWorkPermit(data) {
    const query = "finish_work_permit";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      data,
    };

    return this.http.post(url + query, params, { headers });
  }

  updateUserData(data) {
    const query = "update_user";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      data,
    };

    return this.http.post(url + query, params, { headers });
  }

  updatePassword(data) {
    const query = "update_password";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      data,
    };

    return this.http.post(url + query, params, { headers });
  }

  getTimesControlList(filters = {}) {
    const query = "time_control/list";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      filters,
    };

    return this.http.post(url + query, params, { headers });
  }

  getLoadTimesControlForm(time_control_id = null) {
    let query = "time_control/load_form";
    if(time_control_id){
      query = query + '/' + time_control_id;
    }
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {};
    return this.http.post(url + query, params, { headers });
  }

  getSendTimesControlForm(params) {
    let query = "time_control/send_form";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.post(url + query, params, { headers });
  }

  getZonesList() {
    const query = "time_control/load_filters";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {};

    return this.http.post(url + query, params, { headers });
  }


  //Tareas
  getTaskList(filters = {}, page) {
    const query = "task/list";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    if(page == 0){
      page = 1;
    }

    const params = {
      filters,
      page
    };

    return this.http.post(url + query, params, { headers });
  }

  //Tareas
  getTaskListCalendar(filters = {}) {
    const query = "task/listCalendar";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {
      filters
    };

    return this.http.post(url + query, params, { headers });
  }

  getLoadTaskForm(time_control_id = null) {
    let query = "task/load_form";
    if(time_control_id){
      query = query + '/' + time_control_id;
    }
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {};
    return this.http.post(url + query, params, { headers });
  }

  getSendTaskForm(params) {
    let query = "task/send_form";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.post(url + query, params, { headers });
  }

  updatePreviewTaskData(params) {
    let query = "task/update_previewTask_data";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.post(url + query, params, { headers });
  }

  getTaskPreview(task_id) {
    const query = "task/preview_task/" + task_id;
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.get(url + query, { headers });
  }


  getNotificationsTask(task_id) {
    const query = "task/notifications_task/" + task_id;
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.get(url + query, { headers });
  }

  setNotificationsTask(params) {
    let query = "task/save_notifications_task";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.post(url + query, params, { headers });
  }

  deleteNotificationsTask(params) {
    let query = "task/delete_notifications_task";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.post(url + query, params, { headers });
  }

  getCommentsTask(task_id) {
    const query = "task/comments_task/" + task_id;
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.get(url + query, { headers });
  }

  setCommentsTask(params) {
    let query = "task/save_comment_task";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    return this.http.post(url + query, params, { headers });
  }

  loadFiltersTask() {
    const query = "task/load_filters";
    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    const params = {};

    return this.http.post(url + query, params, { headers });
  }

  setStatusTask(task_id, status_id) {
    let query = "task/set_status_task";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    let params = {
      'task_id': task_id,
      'status_id': status_id
    };

    return this.http.post(url + query, params, { headers });
  }

  archivedTask(task_id) {
    let query = "task/archived_task";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    let params = {
      'task_id': task_id
    };

    return this.http.post(url + query, params, { headers });
  }


  activeTask(task_id) {
    let query = "task/active_task";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    let params = {
      'task_id': task_id
    };

    return this.http.post(url + query, params, { headers });
  }

  deleteTask(task_id) {
    let query = "task/delete_task";

    const url = environment.api;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    });

    let params = {
      'task_id': task_id
    };

    return this.http.post(url + query, params, { headers });
  }

}
